import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { SystemService } from '../services/system.service';

@Component({
  selector: 'app-system-poster',
  templateUrl: './system-poster.component.html',
  styleUrls: ['./system-poster.component.css']
})
export class SystemPosterComponent implements OnInit, OnDestroy {
  @Input() number: number = 1017;
  @Input() posterText: string = '';

  urlQrCode: string | null = null;
  siteId: string | null = null;
  systemNumber: string | null = null;
  systemId: string | null = null;
  companyId: string | null = null;
  errorMessage: string | null = null;

  systemSubscription: any;

  constructor(
    private systemService: SystemService
  ) {}

  ngOnInit(): void {
    // Get url parameters
    const urlParams = new URLSearchParams(window.location.search);
    this.systemNumber = urlParams.get('systemNumber');
    this.systemId = urlParams.get('systemId');

    // console.log('URL parameters:', { systemNumber: this.systemNumber, systemId: this.systemId });

    if (this.systemNumber) {
      console.log('Retrieving system info for systemNumber:', this.systemNumber);
      // Get system info from firebase
      this.systemSubscription = this.systemService.getSystemInfoFromNumber(Number(this.systemNumber)).subscribe(info => {
        console.log('System info retrieved:', info);

        const system = info[0];

        this.siteId = system?.siteId;
        this.systemId = system?.id;
        this.companyId = system?.companyId;

        if (!this.siteId || !this.systemId || !this.companyId) {
          console.error('Missing system information:', { siteId: this.siteId, systemId: this.systemId, companyId: this.companyId });
          this.errorMessage = 'Missing system information';
          return;
        }

        this.urlQrCode = `https://api.qrserver.com/v1/create-qr-code/?size=250x250&data=${environment.appUrl}/init-company?companyId=${this.companyId}%26siteId=${this.siteId}%26systemId=${this.systemId}`;
      });
    } else if (this.systemId) {
      console.log('Retrieving system info for systemId:', this.systemId);
      // Get system info from firebase
      this.systemSubscription = this.systemService.getSystemDetail$(this.systemId).subscribe((system : any )=> {

        console.log('System info retrieved:', system);

        this.siteId = system?.siteId;
        this.systemId = system?.id || this.systemId; // Keep the original systemId if not found in system info
        this.companyId = system?.companyId;
        this.systemNumber = system?.number;

        if (!this.siteId || !this.systemId || !this.companyId) {
          console.error('Missing system information:', { siteId: this.siteId, systemId: this.systemId, companyId: this.companyId });
          this.errorMessage = 'Missing system information';
          return;
        }

        this.urlQrCode = `https://api.qrserver.com/v1/create-qr-code/?size=300x300&data=${environment.appUrl}/init-company?companyId=${this.companyId}%26siteId=${this.siteId}%26systemId=${this.systemId}`;
      
      });
    } else {
      console.error('No systemNumber or systemId provided in URL parameters');
      this.errorMessage = 'No system information provided';
    }
  }
  ngOnDestroy(): void {
    if (this.systemSubscription) {
      this.systemSubscription.unsubscribe();
    }
  }
}
